module.exports = __webpack_public_path__ + "static/img/3-EN.ba012c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_m/3-EN.png
// module id = GGAA
// module chunks = 1